import { TextInput } from '@ts/storybook';
import { IForm } from '@ts/ui-models';

const AppProfileForm = (props: IForm) => {
  const { values, mode, onCallbackChange } = props;

  const isViewMode = mode === 'view';

  return (
    <>
      <TextInput isReadOnly={isViewMode} label="Name" value={values.name} onChangeValue={onCallbackChange('name')} required />
      <TextInput isReadOnly={isViewMode} label="Notes" value={values.notes} onChangeValue={onCallbackChange('notes')} multiline />
    </>
  );
};

export default AppProfileForm;
